import { createComponent as _$createComponent } from "solid-js/web";
import { browserSettingsStore } from "../audio/settings.ts";
import { AircraftInset } from "../career/AircraftInset.tsx";
import { createCareerSurface } from "../shell/career-surface.ts";
import { ScreenShell } from "../shell/ScreenShell.tsx";

/**
 * `/career` — the CAREER MENU and the Aerodrome behind it, in the shell
 * (AD-009).
 *
 * `localStorage` is still the single source of truth: `career-surface.ts`
 * reads and writes the same `career-store.ts` the modern screens used, and a
 * reload at any point in the loop resumes exactly where it was. Coming back
 * from `/fly`, the surface opens on SAFE RETURN or the MISSION DEBRIEFING
 * because the sortie wrote its debriefing into the save before navigating.
 */
export function Career() {
  const controller = createCareerSurface(browserSettingsStore());
  controller.openConsequences();
  return _$createComponent(ScreenShell, {
    controller: controller,
    label: "Career menu",
    inset: box => _$createComponent(AircraftInset, {
      box: box,
      surface: controller
    })
  });
}